import { translateLabel } from "@/i18n/messages";
import React from "react";
import { Link } from "react-router-dom";
import { CalendarBlankIcon, MapPinIcon, ArrowRightIcon } from "@phosphor-icons/react";

/** Compact result for the map-first Events layer. Data comes from published events API. */
export function EventCard({ event, selected = false, onSelect }) {
  if (!event) return null;
  const date = event.startsAt
    ? new Intl.DateTimeFormat("en-GB", {
        day: "2-digit", month: "short", year: "numeric",
        timeZone: event.timeZone || "UTC",
      }).format(new Date(event.startsAt))
    : "Date to be confirmed";
  const location = [event.venueName, event.city].filter(Boolean).join(", ") || "Location to be confirmed";

  return (
    <div
      className={`flex w-full overflow-hidden rounded-xl border text-left transition-colors ${
        selected
          ? "border-lime-400 bg-lime-400/10"
          : "border-white/10 bg-[#1b1b1b] hover:border-lime-400/60"
      }`}
    >
      <button
        type="button"
        onClick={() => onSelect?.(event)}
        aria-pressed={selected}
        className="min-w-0 flex-1 p-3 text-left"
      >
        <div className="flex items-start gap-3">
          {event.imageUrl ? (
            <img src={event.imageUrl} alt="" loading="lazy" className="h-16 w-20 shrink-0 rounded-lg object-cover" />
          ) : (
            <div aria-hidden="true" className="flex h-16 w-20 shrink-0 items-center justify-center rounded-lg bg-white/10 text-lime-400">
              <CalendarBlankIcon size={25} />
            </div>
          )}
          <div className="min-w-0 flex-1">
            <div className="mb-1 flex items-center gap-1 text-xs text-white/60">
              <CalendarBlankIcon size={13} aria-hidden="true" />
              <span>{date}</span>
            </div>
            <div className="truncate text-sm font-semibold text-white">{event.title}</div>
            <div className="mt-1 flex items-center gap-1 text-xs text-white/60">
              <MapPinIcon size={13} aria-hidden="true" />
              <span className="truncate">{location}</span>
            </div>
          </div>
        </div>
      </button>
      <Link
        to={`/events?event=${encodeURIComponent(event.id)}`}
        aria-label={`Open ${event.title}`}
        title={translateLabel("Open event")}
        className="flex w-11 shrink-0 items-center justify-center border-l border-white/10 text-lime-400 transition-colors hover:bg-lime-400/10 hover:text-lime-300"
      >
        <ArrowRightIcon aria-hidden="true" size={16} />
      </Link>
    </div>
  );
}
